import * as yup from 'yup';
import { VALIDATION_MESSAGE } from '../constants/Constants';
import { LanguageConstants } from '../constants/LanguageConstants';



const ChangePasswordValidation: any = yup.object().shape({
    old_password: yup.string()
    .required(LanguageConstants?.OLD_PASSWORD_REQUIRED),
 password: yup.string()
 .required(LanguageConstants?.NEW_PASSWORD_REQUIRED)
 .min(8, LanguageConstants?.NEW_PASSWORD_MIN_CHAR)
 .max(15, LanguageConstants?.NEW_PASSWORD_MAX_CHAR)
 .matches(/^\S*$/, LanguageConstants?.NO_SPACE_ALLOWED)
 .matches(/^(?=.*[a-z])(?=.*[A-Z])/, LanguageConstants?.PASSWORD_REQUIRED) 
 .matches(/^(?=.*[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~])/, LanguageConstants?.PASSWORD_UPPER_CASE)
 .matches(/^(?=.{6,20}$)\D*\d/, LanguageConstants?.PASSWORD_MATCH)
 .test('password-match', LanguageConstants?.NEW_OLD_PASSWORD_SAME, function (value) {
     return value !== this.parent.old_password;
 }),

 confirm_password: yup.string()
    .required(LanguageConstants?.CONFIRM_PASSWORD_REQUIRED)
    .min(8, LanguageConstants?.CONFIRM_PASSWORD_MIN_CHAR)
    .max(15, LanguageConstants?.CONFIRM_PASSWORD_MAX_CHAR)
    .matches(/^\S*$/, LanguageConstants?.NO_SPACE_ALLOWED)
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~`!@#$%^&.,<>?/*:";'{}()=+_-])[A-Za-z\d~`!@#$%^&.,<>?/*:";'{}()=+_-]{8,32}$/, LanguageConstants?.PASSWORD_UPPER_CASE)
    .oneOf([yup.ref('password')], LanguageConstants?.PASSWORD_CONFIRM_PASSWORD_MUST_MATCH),
});

export default ChangePasswordValidation;

